/**
 * @fileoverview Invitations list query key.
 * @description Lives in shared so the feature that owns the Invitations list (features/user-invitations) and the one that has to refresh it when a user is deactivated or reactivated (features/users, whose lifecycle commands revoke or issue invitations) can name it without one feature importing the other (ADR-0002).
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

export const INVITATIONS_QUERY_KEY = ['identity', 'invitations']
